import * as qs from 'query-string';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';

import CircularProgress from '@material-ui/core/CircularProgress';

import { logginVerifying, loginWithToken } from '../actions/authentication';
import { isLoggedIn } from '../utils/authentication';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class TokenResponse extends React.Component<any, any> {
    public async componentDidMount() {
        this.props.dispatch(logginVerifying());
        const parsedHash = qs.parse(this.props.location.hash);
        this.props.dispatch(loginWithToken(parsedHash.access_token as string));
    }
    public render() {
        const session = this.props.authentication
        if (isLoggedIn(session)) {
            return this.loginOk()
        } else {
            return this.loggingIn()
        }
    }
    private loggingIn() {
        return (
            <div>
                <CircularProgress />
            </div>
        )
    }

    private loginOk() {
        return (
            <div>
                <Redirect to='/' />
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(withRouter(connect(
    mapStateToProps,
)(TokenResponse)));



// WEBPACK FOOTER //
// ./src/containers/token-response.tsx